export const urlsPages = {
    home: "/",
    signin: "/entrar",
    signup: "/cadastrar",
    verifyEmail: "/verificar-email",
    drills: "/drills",
    sessionsList: "/sessoes",
    workouts: "/treinos/:drillId",
    actions: "/treinos/:workoutId/acoes",
    connection: "/conexao/:workoutId",
    monitorConnection: "/monitor/:sessionId/conexao",
    monitor: "/monitor/:sessionId",
    sessionExecution: "/sessao/:sessionId",
    validateEmail: "/confirmar-conta",

}